import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect, useRef, type RefObject } from "react";

/**
 * Ref that mirrors the latest committed `value`, for effects, timers and
 * native listeners that must read current props without re-subscribing.
 *
 * Only read it outside render; render-time consumers should use `value`.
 */
export function useLatestRef(value) {
  const $ = _c(3);
  const ref = useRef(value);
  let t0;
  let t1;
  if ($[0] !== value) {
    t0 = () => {
      ref.current = value;
    };
    t1 = [value];
    $[0] = value;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useLayoutEffect(t0, t1);
  return ref;
}